// TODO: show words like "a few minutes ago or yesterday / today etc" instead of date if applicable
import { formattedDateWithMonthName } from 'utils/formattedDate';
import { BaseCellOptionProps, CellProps } from '../types/Cell';
import { DefaultCell } from './DefaultCell';

export const DateCell = (options: CellProps): React.ReactElement => {
  const { label } = options as BaseCellOptionProps;
  const isValidDate = (date: string): boolean => {
    const parsedDate = new Date(date);
    return Number.isInteger(parsedDate.getTime());
  };

  const formattedDate = formattedDateWithMonthName(new Date(label)) || '';

  return (
    <DefaultCell
      textStyle="body.s.regular"
      label={isValidDate(label) ? formattedDate : ''}
      textColor="text.secondary"
    />
  );
};
